<script>
 
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
  import Multiselect from 'vue-multiselect'

export default {
  mixins: [apibtoast, apigeneric],
  components: {
    Multiselect
  },
  props: ["Userid", "title"],
  data: () => ({
    UserData: {},
    AddEdit: "Add",
 
    value: [],
    children: [],
    options: [],
    birimlist: [],
    veri: [],
    clearable: true,
    searchable: true,
    disabled: false,
    openOnClick: true,
    openOnFocus: false,
    clearOnSelect: true,
    alwaysOpen: false,
    appendToBody: false,
    sortValueBy: "ORDER_SELECTED", //LEVEL , INDEX
    valueConsistsOf: "ALL", // "BRANCH_PRIORITY", "LEAF_PRIORITY","ALL_WITH_INDETERMINATE"
    rtl: false,
    flat: false,
    limit: 0,
    selectedOptions: [],
    Id: null
 
  }),
  watch:{
    Userid(){
      this.Get()
    },
 
  },
  methods: {
    async Get() {
 
      var res = await this.ActionsFilterGet({
        Service: "ouserbirimyetki",
        FullData: true,
        Filter: "&Userid=" + this.Userid ,
      }) 
        this.UserData = res.Data;
        this.selectedOptions = [];
        this.FormData.Birimids = [];
        if (res.Data.length > 0) {
          this.Id = res.Data[0].Id;
 
          for (var i = 0; i < res.Data.length; i++) {
            //this.FormData.Birimids.push(res.Data[i].Birimid);
            this.selectedOptions.push({
              id : res.Data[i].Birimid,
              label: res.Data[i].Birimadi
            }
              
            
          );
          }
          this.AddEdit = "Edit";
        }
        else{
          this.AddEdit = "Add";
        }
    
    },
    
    YetkiSubmit() { 
  
      this.FormData.Birimids =  this.FormData.Birimids.filter(item => item !== 1); 
      this.FormData.Userid = this.Userid;  
      if (this.AddEdit == "Add") { 
        delete this.FormData.Id
        this.Post("ouserbirimyetki", this.FormData).then((res) => {
          if (res) {
            this.AddEdit == "Edit";
          }
        });
      } else {
        this.Update("ouserbirimyetki", this.FormData);
      }
    },
    Secim(event){ 
      if (event.id == 1) {  
          if (this.selectedOptions.length === this.options.length ) {  
             
            this.selectedOptions = [];
          } else { 
            this.selectedOptions = this.options.slice(1).map(option => option);  
          }

      } 
    }
  },
  async created() {

    this.ActionsFilterGet({ Service: "OBirim", FullData: true, Filter: "" }).then((res) => {
      this.options = [
                      { id: 1, label: "Tümünü Seç" },
                      ...res.Data.map(item => ({
                        id: item.Id,
                        label: item.Birimadi
                      }))
                    ];
    });

 
    
    await this.Get();
  },

  computed: {
    FormData() {
      return {
        Birimids: this.selectedOptions.map(option => option.id),
        Id : this.Id
      };
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<template>
  <div>
    <b-form-group id="gbirimler" :label="title" label-for="text">
      <div class="row">
        <div class="col-10"> 
       <multiselect
      placeholder="Seçiniz..."
      :multiple="true"
      v-model="selectedOptions"
      :options="options"
      label="label"
      track-by="id"      :close-on-select="false"
      :deselect-label="'Seçimi kaldır'"
      :selected-label="'Seçildi'"
      :select-label="'Seç'"
      :no-results-text="'Sonuç bulunamadı'"
      @select="Secim($event)"

    />

           
        </div>
        <div class="col-2">
          <button class="btn-success" @click="YetkiSubmit()">
            <i class="mdi mdi-account-check-outline"></i>
          </button>
        </div>
      </div>
    </b-form-group>
  </div>
</template>
